<template>
    <div>
        <transition name="slide" mode="out-in">
            <router-view></router-view>
        </transition>
    </div>
</template>

<script>
    import CustomerDashboard from 'components/customer/Dashboard.vue';
    import CustomerEdit from 'components/customer/Edit.vue';

    export default {
        name: "ContentContainer",
        components: {
            CustomerDashboard,
            CustomerEdit
        }
    }
</script>

<style scoped lang="scss">

    .slide-leave-active {
        transition: opacity 0.4s ease;
        opacity: 0;
        animation: slide-out 0.4s ease-out forwards;
    }

    .slide-leave {
        opacity: 1;
        transform: translateY(0);
    }

    .slide-enter-active {
        animation: slide-in 0.4s ease-out forwards;
    }
    
    @keyframes slide-out {
        0% {
            transform: translateY(0);
        }

        100% {
            transform: translateY(30px);
        }
    }

    @keyframes slide-in {
        0% {
            transform: translateY(30px);
        }

        100% {
            transform: translateY(0);
        }
    }
</style>